import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DFormGroup } from "../../entities/form-group";

@Component({
	selector: "form-segment",
	template: ' <div class="dynamic-field form-group" [formGroup]="group"><ng-content select="h3" /></div> ',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormSegmentComponent {
	@Input() config: DFormGroup;
	@Input() group: UntypedFormGroup;
}
